import React from "react";

function StepContent({ StepNumber, StepHeading, StepDesc, isActive, onClick }) {
  return (
    <>
      <div
        className={`item step-list-block ${isActive ? "active" : ""}`}
        onClick={onClick}
      >
        <span className="list-type">{StepNumber}</span>
        <div className="list-content">
          <h4 className="lc-heading">{StepHeading}</h4>
          <p className="lc-desc">{StepDesc}</p>
        </div>
      </div>
    </>
  );
}

export default StepContent;